import { createSlice } from "@reduxjs/toolkit";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    distributionLists: [],
  },
  reducers: {
    setDistributionLists(state, action) {
      const { payload } = action;
      state.distributionLists = payload;
    },
  },
});

export const { setDistributionLists } = settingsSlice.actions;

export const settingsReducer = settingsSlice.reducer;
